import { Card, Typography, List, Button } from "antd";
import { CheckCircleOutlined, StarOutlined } from "@ant-design/icons";
import "./BusinessPricing.scss";

const { Title, Text } = Typography;

const plans = [
  {
    name: "Starter",
    price: "$299",
    period: "/month",
    description: "Perfect for small clinics and practices",
    badge: "Best Value",
    features: [
      "Up to 1,000 patient records",
      "5 user accounts",
      "Basic analytics",
      "Email support",
      "Cloud storage (10GB)",
      "API access",
    ],
    highlighted: false,
  },
  {
    name: "Professional",
    price: "$599",
    period: "/month",
    description: "Ideal for growing healthcare organizations",
    badge: "Most Popular",
    features: [
      "Up to 10,000 patient records",
      "25 user accounts",
      "Advanced analytics & reporting",
      "Priority support (24/7)",
      "Cloud storage (100GB)",
      "Full API integration",
      "Custom workflows",
      "Multi-location support",
    ],
    highlighted: true,
  },
  {
    name: "Enterprise",
    price: "Custom",
    period: "",
    description: "Built for large healthcare networks",
    badge: "Premium",
    features: [
      "Unlimited patient records",
      "Unlimited users",
      "Enterprise analytics suite",
      "Dedicated account manager",
      "Unlimited cloud storage",
      "Custom integrations",
      "White-label options",
      "SLA guarantee",
      "On-premise deployment",
    ],
    highlighted: false,
  },
];

export default function BusinessPricing({ token }) {
  return (
    <div className="businessPricing">
      <div style={{ textAlign: "center", marginBottom: "32px" }}>
        <Title
          level={2}
          style={{ color: token?.colorSecondaryLogo, marginTop: 0 }}>
          Flexible Pricing Plans
        </Title>
        <Text className="businessPricing__description">
          Choose the perfect plan for your organization's needs
        </Text>
      </div>

      <div className="businessPricing__grid">
        {plans.map((plan, index) => (
          <Card
            key={index}
            className={`businessPricing__plan ${
              plan?.highlighted ? "businessPricing__plan--highlighted" : ""
            }`}
            style={{
              border: `3px solid ${
                plan.highlighted
                  ? token?.colorPrimary
                  : token?.colorSecondaryLogo
              }`,
              backgroundColor: token?.Card?.colorBgCard,
              borderRadius: "12px",
              height: "100%",
              position: "relative",
            }}>
            <div
              className="businessPricing__badge"
              style={{
                backgroundColor: plan.highlighted
                  ? token?.colorPrimary
                  : token?.colorSecondaryLogo,
              }}>
              <StarOutlined /> {plan.badge}
            </div>

            <div className="businessPricing__content">
              <div style={{ textAlign: "center" }}>
                <Title
                  level={3}
                  style={{
                    color: plan.highlighted
                      ? token?.colorPrimary
                      : token?.colorSecondaryLogo,
                    margin: 0,
                  }}>
                  {plan?.name}
                </Title>
                <Text className="businessPricing__plan-description">
                  {plan?.description}
                </Text>
              </div>

              <div style={{ textAlign: "center" }}>
                <div className="businessPricing__price">
                  <Title
                    level={2}
                    style={{
                      fontSize: "32px",
                      margin: 0,
                      fontWeight: 700,
                      color: plan?.highlighted
                        ? token?.colorPrimary
                        : token?.colorSecondaryLogo,
                    }}>
                    {plan?.price}
                  </Title>

                  {plan?.period && (
                    <Text
                      style={{
                        color: plan.highlighted
                          ? token?.colorPrimary
                          : token?.colorSecondaryLogo,
                      }}>
                      {plan.period}
                    </Text>
                  )}
                </div>
              </div>

              <List
                dataSource={plan.features}
                renderItem={(item) => (
                  <List.Item className="businessPricing__feature">
                    <CheckCircleOutlined
                      style={{
                        color: plan.highlighted
                          ? token?.colorPrimary
                          : token?.colorSecondaryLogo,
                        fontSize: "16px",
                        marginRight: "8px",
                      }}
                    />
                    <Text>{item}</Text>
                  </List.Item>
                )}
              />

              <Button
                size="large"
                type={plan?.highlighted ? "primary" : "default"}
                className={
                  !plan?.highlighted ? "businessPricing__button--default" : ""
                }
                block>
                {plan?.name === "Enterprise" ? "Contact Sales" : "Get Started"}
              </Button>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
